import request from '@/utils/request'

// 获取报价单列表
export function quotelist(params) {
  return request({
    url:'/Crm.Quote/quote_list',
    method:'get',
    params:params
  })
}

// 新建报价单
export function addQuote(data) {
  return request({
    url:'/Crm.Quote/quote_add',
    method:'post',
    data:data
  })
}
// 报价单拆单
export function cut_quote(data) {
  return request({
    url:'/Crm.Quote/cut_quote',
    method:'post',
    data:data
  })
}
// 修改报价单表头
export function quoteUpdate(data) {
  return request({
    url:'/Crm.Quote/quote_update',
    method:'post',
    data:data
  })
}
// 删除报价单
export function deleteQuote(data) {
  return request({
    url:'/Crm.Quote/quote_delete',
    method:'post',
    data:data
  })
}
// 合并报价单
export function mergeQuote(data) {
  return request({
    url:'/Crm.Quote/merge_quote',
    method:'post',
    data:data
  })
}
// 操作报价单
export function quoteUpdateAll(data) {
  return request({
    url:'/Crm.Quote/quote_op',
    method:'post',
    data:data
  })
}

// 报价单行项目添加
export function lineAdd(data) {
  return request({
    url:'/Crm.Quote/quote_line_add',
    method:'post',
    data:data
  })
}
// 产品搜索
export function productSearch(data) {
  return request({
    url:'/Crm.Quote/productSearch',
    method:'post',
    data:data
  })
}

// 删除报价单行项目
export function deleteLine(data) {
  return request({
    url:'/Crm.Quote/quote_line_delete',
    method:'post',
    data:data
  })
}
// 查看报价单详情
export function quoteView(params) {
  return request({
    url:'/Crm.Quote/quote_view',
    method:'get',
    params:params
  })
}
export function quoteView2(params,keyToken) {
  return request({
    url:'/Crm.Quote/detail',
    method:'get',
    params:params,
    keyToken,
  })
}
// 获取客户信息
export function customeInfo(params) {
  return request({
    url:'/Crm.Quote/get_customer_information',
    method:'get',
    params:params
  })
}
// 审核和返审核报价单
export function reviewQuotation(data) {
  return request({
    url:'/Crm.Quote/review_quotation',
    method:'post',
    data:data
  })
}
// 修改备注、数量、销售价
export function quoteItemsUpdate(data) {
  return request({
    url:'/Crm.Quote/quoteItemsUpdate',
    method:'post',
    data:data
  })
}
// 修改备注、数量、销售价
export function quoteItemsUpdate2(data,keyToken) {
  return request({
    url:'/Crm.Quote/quoteItemsUpdate',
    method:'post',
    data:data,
    keyToken,
  })
}
// 生成订单,报价单转订单
export function quoteToOder(data) {
  return request({
    url:'/Crm.Orders/QuoteToOrder',
    method:'post',
    data:data
  })
}

// 导入EXCEL到报价单
export function ImportExcelToQuotation(data) {
  return request({
    url:'/Crm.Quote/ImportExcelToQuotation',
    method:'post',
    data:data
  })
}

// 导出报价单到EXCEL
export function exportQuotationToExcel(params) {
  return request({
    url:'/Crm.Quote/exportQuotationToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}
// 报价历史
export function auotationHistory(params) {
  return request({
    url:'/Crm.Quote/auotationHistory',
    method:'get',
    params:params
  })
}
// 导出报价历史到EXCEL
export function exportQuotationHistoryToExcel(params) {
  return request({
    url:'/Crm.Quote/exportQuotationHistoryToExcel',
    method:'get',
    params:params,
    responseType: "blob"
  });
}

// 报价单开单页面-下拉框数据
export function enumList(params) {
  return request({
    url:'/Crm.Quote/enum_list',
    method:'get',
    params:params
  })
}

// 审核报价单-通过key登录CRM
export function loginKey(data) {
  return request({
    url:'/User/login_key',
    method:'post',
    data:data
  })
}
// CRM报价单审核-一键通过
export function passAll(data,keyToken) {
  return request({
    url:'/Crm.Quoteaudit/pass_all',
    method:'post',
    data:data,
    keyToken
  })
}
// CRM报价单审核-批量通过，驳回
export function passUpdate(data,keyToken) {
  return request({
    url:'/Crm.Quoteaudit/update',
    method:'post',
    data:data,
    keyToken
  })
}

export function historyPrice(data) {
  return request({
    url:'/Crm.Product/history_price',
    method:'post',
    data:data
  })
}


export function UserConfig(data) {
  return request({
    url:'/Tools.UserConfig/index',
    method:'post',
    data:data
  })
}

export function UserConfigSave(data) {
  return request({
    url:'/Tools.UserConfig/save',
    method:'post',
    data:data
  })
}
export function customExportQuotationToExcel(data) {
  return request({
    url:'/Crm.Quote/customExportQuotationToExcel',
    method:'post',
    data:data,
    header:{
      'Content-Type': 'multipart/form-data'
    },
    responseType: "blob",
  })
}
export function customExportOrderToExcel(data) {
  return request({
    url:'/Crm.Orders/customExportOrderToExcel',
    method:'post',
    data:data,
    header:{
      'Content-Type': 'multipart/form-data'
    },
    responseType: "blob",
  })
}



// WEBPACK FOOTER //
// ./src/api/quotedPrice.js